var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{attrs:{"id":"blog-header"}},[_c('div',{staticClass:"inner "},[_c('h1',{staticClass:"blog-name"},[_c('router-link',{attrs:{"to":{ name: 'tagContent', params: { tag: _vm.tag }}}},[_vm._v(_vm._s(_vm.tag))])],1)])]),_vm._v(" "),_c('all-blogposts',{key:_vm.refresh,attrs:{"func":_vm.func}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6e8aafc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TagContent.vue
// module id = null
// module chunks = 